var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-open-app",on:{"click":_vm.button}},[_c('OpenApp',{attrs:{"unitKey":_vm.unitKey,"options":_vm.options,"appendParam":_vm.appendParam}},[_c('div',{staticClass:"button"},[_vm._v("APP内打开")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }